
const Ryplazim = ({ themeColor }: { themeColor: string }) => {
  return (
    <>
      <div className="mx-auto pb-10">
        <div className="text-xl md:text-3xl font-bold text-[#000000]">
          <span style={{ color: themeColor }}>MEDICAL BENEFITS BILLING PORTAL FOR PROVIDERS. </span>
          <p className="my-2">SITE-OF-CARE DRIVEN COPAY ASSISTANCE.</p>
        </div>

        <p className="my-2">
          If your patient’s primary payer drug claim is billed under medical benefits, you can request RYPLAZIM (plasminogen, human-tvmh) copay assistance using this portal. ​Eligible patients can receive up to $20,000 over 12 months to cover the deductible, copay, and/or coinsurance for RYPLAZIM.
        </p>

        <p className="my-2 ">
          <b>Note: </b> Nursing and supply costs that may be associated with the administration of the medication are not eligible for assistance through this program. For both medical and pharmacy benefits, claims must be received within 30 days of dispense date. &nbsp;
          <b>For medical benefits only, EOBs must also be submitted within 120 days of the date the claim was submitted.</b>
        </p>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE
        </div>

        <ul className="my-2 list-disc ml-10">
          <li>Patients must be commercially insured.</li>
          <li>
            Patients must express a financial need.
          </li>
          <li>
            Assistance available for the treatment of congenital Plasminogen Deficiency / Plasminogen Deficiency Type 1.
          </li>
          <li>
            Patients' health plan permits members to participate in copay assistance programs
          </li>
        </ul>

        <div className="font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Not valid for prescriptions eligible for reimbursement by any federal or state healthcare programs, such as
            Medicare, Medicaid, Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or
            state-funded programs.
          </li>
        </ul>
      </div>
    </>
  )
}

export default Ryplazim;
